import { render, staticRenderFns } from "./merge-organizations-side-action.vue?vue&type=template&id=6759ffb0"
import script from "./merge-organizations-side-action.ts?vue&type=script&lang=js&external"
export * from "./merge-organizations-side-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports